import { defineStore } from 'pinia';
import {ref} from 'vue';

export const useTicketStore = defineStore('ticket', () => {
    const selectedDateStart = ref("");
    const selectedDateEnd = ref("");
    const step = ref(0)
    const hideServiceView = ref(false);
    const selectedOption = ref("");
    const selectedInsurance = ref("no_insurance");
    const selectedUpgrades = ref([]);
    const selectedCurrency = ref("CHF");
    const selectedPriceGroup = ref(null);
    const selectedPriceConfiguration = ref({});
    const allPriceGroups = ref([]);
    const allInsurances = ref([]);
    const allOptions = ref([]);
    const allUpgrades = ref([]);
    const stepValidation = ref({});
    const minSelectableDates = ref(0);
    const noAvailableDates = ref(false);
    const presalesExpiredMessage = ref(false);
    const specialPriceModals = ref([]);
    const checkedLegalDisclaimers = ref([]);

    const setSpecialPriceModals = (modals) => {
        specialPriceModals.value = modals;
    };

    // for pricecalculator:
    const preselectedOption = ref("");
    const preselectedUpgrades = ref([]);

    const ticketConfigurations = ref({
        priceGroups: {},
        persons: {},
        configurations: [],
        finalPrice: 0,
    });

    const hideSpecialPriceModal = ref(false);

    const setHideSpecialPriceModal = (status) => {
        hideSpecialPriceModal.value = status;
    };

    function changeNoAvailableDates(value) {
        noAvailableDates.value = value;
    }

    function changeStep(value) {
        step.value = value;
    }

    function changeDateStart(value) {
        selectedDateStart.value = value;
    }

    function changeDateEnd(value) {
        selectedDateEnd.value = value;
    }

    function changeOption(value) {
        selectedOption.value = value;
    }

    function changeInsurance(value) {
        selectedInsurance.value = value;
    }

    function changeUpgrades(value) {
        selectedUpgrades.value = value;
    }

    function changeCurrency(value) {
        selectedCurrency.value = value;
    }

    function changePriceGroup(value) {
        selectedPriceGroup.value = value;
    }

    async function changePriceConfiguration(value) {
        selectedPriceConfiguration.value = value;
    }

    function changeFinalPrice(value) {
        ticketConfigurations.value.finalPrice = value;
    }

    function changeAllPriceGroups(value) {
        allPriceGroups.value = value;
    }

    function changeTicketConfigurations(value) {
        ticketConfigurations.value = value;
    }

    function changeConfigurations(value) {
        ticketConfigurations.value.configurations = value;
    }

    function changeAllInsurances(value) {
        allInsurances.value = value;
    }

    function changeAllOptions(value) {
        allOptions.value = value;
    }

    function changeAllUpgrades(value) {
        allUpgrades.value = value;
    }

    function changeStepValidation(value) {
        stepValidation.value = value;
    }

    function changeHideServiceView(value) {
        hideServiceView.value = value;
    }

    function changeMinSelectableDates(value) {
        minSelectableDates.value = value;
    }

    function changePresalesExpiredMessage(value) {
        presalesExpiredMessage.value = value;
    }

    function changePreselectedOption(value) {
        preselectedOption.value = value;
    }

    function changePreselectedUpgrades(value) {
        preselectedUpgrades.value = value;
    }

    function changeCheckedLegalDisclaimers(value) {
        checkedLegalDisclaimers.value = value;
    }

    function resetServiceStep() {
        changeAllUpgrades([]);
        changeAllOptions([]);
        changeAllInsurances([]);
        changePriceConfiguration({});
        changeInsurance("no_insurance");
        changeOption("");
        changeUpgrades([]);
        changeTicketConfigurations({
            priceGroups: {},
            persons: {},
            configurations: [],
            finalPrice: 0,
        });
        changePreselectedOption('');
        changePreselectedUpgrades([]);
    }

    function resetAll() {
        changeDateStart("");
        changeDateEnd("");
        changeStep(0);
        changeHideServiceView(false);
        changePriceGroup(null);
        changeFinalPrice(0);
        changeStepValidation({});
        changeAllUpgrades([]);
        changeAllOptions([]);
        changeAllInsurances([]);
        changeAllPriceGroups([]);
        changePriceConfiguration({});
        changeInsurance("no_insurance");
        changeOption("");
        changeUpgrades([]);
        changeNoAvailableDates(false);
        changePresalesExpiredMessage(false);
        changeTicketConfigurations({
            priceGroups: {},
            persons: {},
            configurations: [],
            finalPrice: 0,
        })
        changePreselectedOption('');
        changePreselectedUpgrades([]);
        changeCheckedLegalDisclaimers([]);
    }

    return {
        changeDateStart,
        selectedDateStart,
        selectedDateEnd,
        changeDateEnd,
        changeStep,
        selectedOption,
        changeOption,
        selectedInsurance,
        changeInsurance,
        selectedUpgrades,
        changeUpgrades,
        selectedCurrency,
        changeCurrency,
        changePriceGroup,
        selectedPriceGroup,
        selectedPriceConfiguration,
        changePriceConfiguration,
        allPriceGroups,
        changeAllPriceGroups,
        noAvailableDates,
        changeNoAvailableDates,
        ticketConfigurations,
        changeTicketConfigurations,
        allInsurances,
        changeAllInsurances,
        allOptions,
        changeAllOptions,
        allUpgrades,
        changeAllUpgrades,
        hideServiceView,
        changeHideServiceView,
        stepValidation,
        changeStepValidation,
        changeConfigurations,
        changeFinalPrice,
        resetServiceStep,
        changeMinSelectableDates,
        minSelectableDates,
        presalesExpiredMessage,
        changePresalesExpiredMessage,
        preselectedOption,
        changePreselectedOption,
        preselectedUpgrades,
        changePreselectedUpgrades,
        resetAll,
        step,
        specialPriceModals,
        setSpecialPriceModals,
        hideSpecialPriceModal,
        setHideSpecialPriceModal,
        checkedLegalDisclaimers,
        changeCheckedLegalDisclaimers
    }
})